import { subscriptionConstants } from "./constants/subscriptionConstants";

const getSubscriptionPlanRequest = (planName: string) => ({
  type: subscriptionConstants.getSubscriptionPlanRequest,
  payload: planName,
});

const createSubscriptionRequest = (data: any) => ({
  type: subscriptionConstants.createSubscriptionRequest,
  payload: data,
});

const getSubscriptionStatusRequest = (subscriptionId: string) => ({
  type: subscriptionConstants.getSubscriptionStatusRequest,
  payload: subscriptionId,
});



const getOrderStatusRequest = (orderId: string) => ({
  type: subscriptionConstants.getOrderStatusRequest,
  payload: orderId,
});

const syncPlansRequest = () => ({
  type: subscriptionConstants.syncPlansRequest,
});

const getAllPlansRequest = () => ({
  type: subscriptionConstants.getAllPlansRequest,
});

const getUserSubscriptionStatusRequest = () => ({
  type: subscriptionConstants.getUserSubscriptionStatusRequest,
});

const getSubscriptionSyncStatusRequest = (data: any) => ({
  type: subscriptionConstants.getSubscriptionSyncStatusRequest,
  payload: data,
});
/* ----------------- Super Admin: Subscription Plan management ---------------- */

const listAdminPlansRequest = (params: any) => ({
  type: subscriptionConstants.listAdminPlansRequest,
  payload: params,
});

const viewAdminPlanRequest = (id: string) => ({
  type: subscriptionConstants.viewAdminPlanRequest,
  payload: id,
});

// data: { data, id? } — when id is present the saga performs an update
const saveAdminPlanRequest = (data: any) => ({
  type: subscriptionConstants.saveAdminPlanRequest,
  payload: data,
});

const deleteAdminPlanRequest = (id: string) => ({
  type: subscriptionConstants.deleteAdminPlanRequest,
  payload: id,
});

const getRoutesRequest = () => ({
  type: subscriptionConstants.getRoutesRequest,
});

const getInvoiceRequest = (invoiceId: string) => ({
  type: subscriptionConstants.getInvoiceRequest,
  payload: invoiceId,
});

const getAllInvoicesRequest = (data: any) => ({
  type: subscriptionConstants.getAllInvoicesRequest,
  payload: data,
});

const getInvoicePDFRequest = (data: any) => ({
  type: subscriptionConstants.getInvoicePDFRequest,
  payload: data,
});

const getOverallInvoicesRequest = (data: any) => ({
  type: subscriptionConstants.getOverallInvoicesRequest,
  payload: data,
});

export const subscriptionActions = {
  getSubscriptionPlanRequest,
  createSubscriptionRequest,
  getSubscriptionStatusRequest,
  getOrderStatusRequest,
  getAllPlansRequest,
  syncPlansRequest,
  getUserSubscriptionStatusRequest,
  listAdminPlansRequest,
  getSubscriptionSyncStatusRequest,
  viewAdminPlanRequest,
  saveAdminPlanRequest,
  deleteAdminPlanRequest,
  getRoutesRequest,
  getInvoiceRequest,
  getAllInvoicesRequest,
  getInvoicePDFRequest,
  getOverallInvoicesRequest,
};
